"use strict";

import 'bootstrap';
import Flickity from 'flickity';
import FlickityFade from 'flickity-fade';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import 'lity';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'flickity/dist/flickity.min.css';
import 'lity/dist/lity.min.css';

import '../sass/app.scss';

(function($) {

	var map;
    var msnry;

	function new_map( $el ) {
        var $markers = $el.find('.marker');
        var args = {
            zoom        : 15,
            center      : new google.maps.LatLng(0, 0),
            mapTypeId   : google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            rotateControl: false,
            draggable: !("ontouchend" in document)
        };    
        var map = new google.maps.Map( $el[0], args);
        map.markers = [];
        $markers.each(function(){
            add_marker( $(this), map );
        });
        center_map( map );
        google.maps.event.addDomListener(window, "resize", function() {
           center_map(map);
        });
        return map;
    }

    function add_marker( $marker, map ) {
        var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );
        var image = new google.maps.MarkerImage(
            $('#mapMarker').attr('src'),
            null,
            null,
            null,
            new google.maps.Size(50, 71)
        );
        var marker = new google.maps.Marker({
            position    : latlng,
            map         : map,
            icon: image,
            draggable: false
        });
        map.markers.push( marker );
        if( $marker.html() )
        {
            var infowindow = new google.maps.InfoWindow({
                content     : $marker.html()
            });
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }

    function center_map( map ) {
        var bounds = new google.maps.LatLngBounds();
        $.each( map.markers, function( i, marker ){
            var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
            bounds.extend( latlng );
        });
        if( map.markers.length == 1 )
        {
            map.setCenter( bounds.getCenter() );
            map.setZoom( 15 );
        }
        else
        {
            map.fitBounds( bounds );
        }
    }

	// SET IMG
	$.fn.setImg = function() {
		var bg = $(this).data('img');
		$(this).css({
			'background-image': 'url(' + bg + ')'
		});
	};

	// MAKE SQUARE
	$.fn.makeSquare = function() {
		$(this).css({
			'height': parseInt($(this).width(), 10)
		});
	};

	// MAKE RECTANGLE
	$.fn.makeRectangle = function() {
		var ratio = $(this).data('ratio');
		$(this).css({
			'height': parseInt($(this).width() * ratio, 10)
		});
	};

    $.fn.hasHorizontalScrollBar = function() {
        return this.get(0).scrollWidth > this.outerWidth();
    }

	function init() {

		$('.rectangle').each(function(index, elem) {
			$(elem).makeRectangle();
		});

		$('.square').each(function(index, elem) {
			$(elem).makeSquare();
		});

		$('.fixed-container').each(function(index, elem) {
			$(elem).height($(elem).children('.fixed').outerHeight(true));
		});

        if($('.masonry').length) {
            imagesLoaded( '.masonry', function() {
                msnry.layout();
            });
        }

        if($('#headerBottomContainer .scroll-overlay').length) {
            if($('#headerBottom').hasHorizontalScrollBar()) {
                $('#headerBottomContainer .scroll-overlay').show();
            }
            else {
                $('#headerBottomContainer .scroll-overlay').hide();
            }
        }

	}

	$(document).ready(function() {

		$('.imgToDiv').each(function(index, elem) {
			$(elem).setImg();
		});

        if($('.slideshow').length) {
            var flktyfade = new FlickityFade( '.slideshow', {
                fade: true,
                pageDots: false,
                prevNextButtons: false,
                autoPlay: 5000,
                pauseAutoPlayOnHover: false
            });
        }

		if($('.carousel').length) {
            var flkty = new Flickity( '.carousel', {
                wrapAround: true,
                pageDots: false,
                autoPlay: 5000,
                pauseAutoPlayOnHover: false
            });
        }

        if($('.masonry').length) {
            msnry = new Masonry( '.masonry', {
                itemSelector: '.grid-item',
                columnWidth: '.grid-sizer',
                percentPosition: true,
                transitionDuration: 0
            });
        }

		$('body').on('click', '#menuOpen:not(.is-transitioning), #menuClose:not(.is-transitioning), #menuOverlay:not(.is-transitioning)', function(e) {
			e.preventDefault();
			$('#menuOpen, #menuClose, #menuOverlay, #offcanvas, #uberContainer, #header, #headerBottomContainer, body, html').addClass('is-transitioning').toggleClass('menu-open');
			setTimeout(function() {
				$('#menuOpen, #menuClose, #menuOverlay, #offcanvas, #uberContainer, #header, #headerBottomContainer, body, html').removeClass('is-transitioning');
			}, 300);
		});

		$('.acf-map').each(function(){
            map = new_map( $(this) );
        });

        $("#tornaSu").on('click', function() {
            $("html, body").animate({ scrollTop: 0 }, "slow");
            return false;
        });

        $('.collapse').on('show.bs.collapse hide.bs.collapse', function() {
            $(this).parent().find('.panel-icon').toggleClass('hidden');
        });

        if($('#headerBottomContainer .scroll-overlay').length) {
            $('#headerBottom').on('scroll', function() {
                if($(this).get(0).scrollWidth - $(this).get(0).scrollLeft - $(this).outerWidth() > 40) {
                    $('#headerBottomContainer .scroll-overlay').show();
                }
                else {
                    $('#headerBottomContainer .scroll-overlay').hide();
                }
            });
            $('#headerBottomContainer .scroll-overlay').on('click', function() {
                $('#headerBottom').animate({scrollLeft: $('#headerBottom').scrollLeft() + $(window).width()});
            });
        }

		init();

	});

	$(window).on('load', function() {
		init();
	});

	$(window).on('resize', function() {
		init();
	});

})(jQuery);